import { useState } from "react"
import InputBox from "../../../common/interactive/InputBox"
import CustomSelect from "../../../common/interactive/CustomSelect"
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"
import TextareaBox from "../../../common/interactive/TextareaBox"
import Button from "../../../common/Button"
import { formatDate, returnPractice } from "../../../../lib/script"
import { practiceSpecificLocationOptions } from "../../../../lib/systemData"
import { createTransferRequest } from "../../../../lib/fetchApi"
import { useDispatch, useSelector } from "react-redux"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"

export default function TransferToClinicForm({closeModalHandler, practiceData}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [selectedClinic, setSelectedClinic] = useState(false)
    const [formErrors, setFormErrors] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    function onClinicChange(value) {
        setSelectedClinic(value.data.value)
    }

    function validateInputs(clinic, date, reason) {
        if (!clinic || !date || !reason) {
            return 'Some fields require your Attention'
        }
        return null
    }

    async function transferClinicHandler(event) {
        event.preventDefault()
        setLoading(true)
        setFormErrors(false)
        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            if (validateInputs(formData.new_clinic, formData.date, formData.reason)) {
                setFormErrors(validateInputs(formData.new_clinic, formData.date, formData.reason))
                return;
            }

            let reqBody = {
                case_practice_id: practiceData.id,
                to_location_id: formData.new_clinic,
                first_appointment_date: formatDate(formData.date),
                reason: formData.reason
            }

            let createTransfer = await createTransferRequest(userToken, activeCase.case.id, reqBody, dispatch)
            if (createTransfer?.errorMessage) {
                dispatch(notificationActions.setError(createTransfer))     
            } else {            
                dispatch(notificationActions.setError({errorMessage: `Transfer Created!`, type: 'success'}))    
                
                let dispatchBody = {
                    case_practice_id: practiceData.id,
                    item: createTransfer
                }   
                dispatch(caseActions.updateTransfersOnPractices(dispatchBody)) 

                if (closeModalHandler) {
                    closeModalHandler()
                }
            }
        } finally {
            setLoading(false)
        }
    }


    return <form onSubmit={transferClinicHandler}>
        
        <div className="row">
            <InputBox label={'Current Clinic'} type={'text'} currentValue={returnPractice(practiceData?.practice_id)?.locations?.find(loc => loc.id == practiceData?.location_id)?.code} name={'current_Clinic'} isNotModifiable={true}/>{/* display_name */}
        </div>
        <div className="row">
            <CustomSelect name={'new_clinic'} label={'New Clinic'} optionsData={practiceSpecificLocationOptions(practiceData?.practice_id)} action={onClinicChange} preSelectedValue={selectedClinic} />
        </div>

        <div className="row">
            <DatepickerWithLabel label={'Date of Appointment First Visit'} name={'date'}  minDate={new Date()}/>
            <p><small>Please create the transfer appointment in NextGen first</small></p>
        </div>
        <div className="row">
            <TextareaBox label={'Reason'} name={'reason'}/>
        </div>
        
        <div className="row">                                    
            <div className='flex-container-equal m-top-24'>
                <Button btnStyle={'btn_danger'} type={'submit'} isLoading={loading}><i className="ti ti-transfer-in"></i>Transfer</Button>
                <Button click={closeModalHandler} type={'button'}>Cancel</Button>
            </div>     
        </div>   
        {formErrors && <div >
            <p className="danger"><small>{formErrors}</small></p>
        </div> }
    </form>
}